import { Routes } from '@angular/router';
import { CadastroEmpresaComponent } from './pages/(Empresa)/cadastro-empresa/cadastro-empresa.component';
import { TicketAgendamentoEmpresaComponent } from './pages/(Empresa)/agendamento/ticket-agendamento/ticket-agendamento.component';
import { CadastroPagamentoAgendamentoEmpresaComponent } from './pages/(Empresa)/agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';
import { ListagemCarretaEmpresaComponent } from './pages/(Empresa)/cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { appGuard } from './services/auth.guard';
import { ListagemCavaloEmpresaComponent } from './pages/(Empresa)/cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { ListagemAgendamentoEmpresaComponent } from './pages/(Empresa)/agendamento/listagem-agendamento/listagem-agendamento.component';
import { CadastroCavaloEmpresaComponent } from './pages/(Empresa)/cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { CadastroCarretaEmpresaComponent } from './pages/(Empresa)/cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { CadastroAgendamentoEmpresaComponent } from './pages/(Empresa)/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { ListagemLaudosHigienizacaoEmpresaComponent } from './pages/(Empresa)/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoEmpresaComponent } from './pages/(Empresa)/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosEmpresaComponent } from './pages/(Empresa)/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { ListagemServicosEmpresaComponent } from './pages/(Empresa)/servicos/listagem-servicos/listagem-servicos.component';
import { CadastroMotoristaEmpresaComponent } from './pages/(Empresa)/cadastro-frota/motorista/cadastro-motorista/cadastro-motorista.component';
import { ListagemMotoristaEmpresaComponent } from './pages/(Empresa)/cadastro-frota/motorista/listagem-motorista/listagem-motorista.component';
import { ClearRouteGuard } from './core/guard/clear-route.guard';
import { ListagemFuncionarioEmpresaComponent } from './pages/(Empresa)/acesso/funcionario/listagem-funcionario/listagem-funcionario.component';
import { CadastroFuncionarioEmpresaComponent } from './pages/(Empresa)/acesso/funcionario/cadastro-funcionario/cadastro-funcionario.component';

export const empresaRoutes: Routes = [
  {
    path: 'empresa/cadastro-empresa',
    component: CadastroEmpresaComponent
  },
  {
    path: 'empresa/ticket-agendamento',
    component: TicketAgendamentoEmpresaComponent
  },
  {
    path: 'empresa/pagamento',
    component: CadastroPagamentoAgendamentoEmpresaComponent
  },
  {
    path: 'empresa/listagem',
    children: [
      {
        path: 'carreta',
        component: ListagemCarretaEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'cavalo',
        component: ListagemCavaloEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'motorista',
        component: ListagemMotoristaEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'agendamento',
        component: ListagemAgendamentoEmpresaComponent,
        canActivate: [appGuard],
        canDeactivate: [ClearRouteGuard]
      },

      {
        path: 'servicos',
        component: ListagemServicosEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'laudos-higienizacao',
        component: ListagemLaudosHigienizacaoEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'funcionario',
        component: ListagemFuncionarioEmpresaComponent,
        canActivate: [appGuard]
      }
    ]
  },
  {
    path: 'empresa/cadastro',
    children: [
      {
        path: 'cavalo',
        component: CadastroCavaloEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'carreta',
        component: CadastroCarretaEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'motorista',
        component: CadastroMotoristaEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'funcionario',
        component: CadastroFuncionarioEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'agendamento',
        component: CadastroAgendamentoEmpresaComponent,
        canActivate: [appGuard],
        canDeactivate: [ClearRouteGuard]
      },
      {
        path: 'laudo-higienizacao',
        component: CadastroLaudoHigienizacaoEmpresaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'servicos',
        component: CadastroEntradaServicosEmpresaComponent,
        canActivate: [appGuard]
      }
    ]
  },
  {
    path: 'empresa/edicao',
    children: [
      {
        path: 'cadastro',
        component: CadastroEmpresaComponent,
        canActivate: [appGuard]
      }
    ]
  }
];
